import { render } from "./BrushSvg.vue?vue&type=template&id=3a2e916c"
import script from "./BrushSvg.vue?vue&type=script&lang=js"
export * from "./BrushSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__